function layer_ntc_aboriginal(){
    let geoJson = raw_data["原住民部落範圍"]
    let tribeMapping = {}
    if (!geoJson) {
        geoJson = ajax_call("geojson/hillslope/ntc_aboriginal.geojson")
    }
    let thisLayer = L.geoJSON(geoJson, {
        style: function(feature){
            return { color: 'white', weight: 2, opacity: 1, fillOpacity: 0.7, fillColor: 'brown' }
        },
        onEachFeature: function (feature, layer) {
            tribeMapping[feature.properties.aboriginal_name] = feature.properties
            layer.bindPopup('<div id="other_div" class="w-250">讀取中...</div>');
        }
    }).on('click', function(e){
        console.log(tribeMapping)
		let thisFeature = e.layer.feature.properties
		setTimeout(function(){
			$('#other_div').html(`
                <h6 class="m-0">部落名稱：${thisFeature.aboriginal_name}</h6>
                <h6 class="m-0">族系：${thisFeature.aboriginal_ethnic}</h6>
                <div id="tribe_div"></div>
                <div id="survey_record_div"></div>`
			)
            ajax_call_async(
                publicPath + "/napi/obs/hillslopecommunity/abnormal/detailed/" + thisFeature.aboriginal_name,
                function(data) {
                    $("#tribe_div").html(`
                        <h6 class="m-0">調查時間：${data.date_listed.slice(0,4)}年${data.date_listed.slice(4,6)}月</h6>
                        <h6 class="m-0">鄰：${data.neighborhood}鄰</h6>
                        <h6 class="m-0">部落人口數：${data.population}</h6>
                        <h6 class="m-0">原民人口數：${data.population_aboriginal}</h6>
                        <h6 class="m-0">主要從事產業：${data.main_production_industry}</h6>
                        <h6 class="m-0">社團或協會組織：${data.associations_organized}</h6>`
                    )
                }
            )
            ajax_call_async(
                publicPath + "/napi/obs/hillslopecommunity/abnormal/datelist",
                function(data) {
                    var html = ""
                    data.forEach(element => {
                        html += `
                            <li class="my-2">${element.slice(0,4)}年${element.slice(4,6)}月 <button type="button" class="btn btn-success btn-sm py-0 aboriginal-download" target-date="${element}">下載</button> <button type="button" class="btn btn-danger btn-sm py-0 ml-2 aboriginal-delete" target-date="${element}">刪除</button></li>`
                    })
                    $("#survey_record_div").html(`
                        <h6 class="m-0">調查記錄<button type="button" class="btn btn-success btn-sm py-0 ml-2" id="aboriginal-upload-trig">數據上傳</button></h6>
                        <ul>${html}</ul>`
                    )
                    if (html === "") {
                        html = "無紀錄"
                    }
                    $("button.aboriginal-download").click(function(){
                        var targetDate = $(this).attr("target-date")
                        ajax_call_async(
                            publicPath + "/napi/obs/hillslopecommunity/abnormal/table/" + targetDate,
                            function(data){
                                var exportArray = [["部落名稱", "行政區", "村里", "主要民族", "資料日期", "鄰", "主要的從事產業", "部落人口數", "原住民族人口數", "社團或協會組織"]]
                                data.forEach(el => {
                                    el = Object.assign(el, {
                                        aboriginal_name: tribeMapping[el.name].aboriginal_name,
                                        aboriginal_ethnic: tribeMapping[el.name].aboriginal_ethnic,
                                        TOWNNAME: tribeMapping[el.name].TOWNNAME,
                                        VILLNAME: tribeMapping[el.name].VILLNAME
                                    })
                                    exportArray.push([el.name, el.TOWNNAME, el.VILLNAME, el.aboriginal_ethnic, el.date_listed, el.neighborhood, el.main_production_industry, el.population, el.population_aboriginal, el.associations_organized])
                                })
                                downloadxlsx("原住民部落資訊表_" + targetDate + ".xlsx", ["原住民部落清單"], [exportArray])
                            }
                        )
                    })
                    $("button.aboriginal-delete").click(function(){
                        var targetDate = $(this).attr("target-date")
                        ajax_call_async(
                            publicPath + "/napi/obs/hillslopecommunity/abnormal/delete/" + thisFeature.aboriginal_name + "/" + targetDate,
                            function(data){
                                if (data.status === "OK") {
                                    toast_open(`${targetDate}${thisFeature.aboriginal_name}資料刪除成功`)
                                }
                            }
                        )
                    })
                    $("#aboriginal-upload-trig").click(function(){
                        modal_open(`
                            <div class="input-group input-group-sm mb-2">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">部落名稱</span>
                                </div>
                                <input type="text" class="form-control aboriginal-upload-field" target-key="aboriginal_name" value="${thisFeature.aboriginal_name}" disabled>
                            </div>
                            <div class="input-group input-group-sm mb-2">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">調查年月</span>
                                </div>
                                <select class="custom-select aboriginal-upload-field" target-key="year">
                                    <option value="2022">2022年</option>
                                    <option value="2023">2023年</option>
                                    <option value="2024">2024年</option>
                                    <option value="2025">2025年</option>
                                </select>
                                <select class="custom-select aboriginal-upload-field" target-key="month">
                                    <option value="01">1月</option>
                                    <option value="02">2月</option>
                                    <option value="03">3月</option>
                                    <option value="04">4月</option>
                                    <option value="05">5月</option>
                                    <option value="06">6月</option>
                                    <option value="07">7月</option>
                                    <option value="08">8月</option>
                                    <option value="09">9月</option>
                                    <option value="10">10月</option>
                                    <option value="11">11月</option>
                                    <option value="12">12月</option>
                                </select>
                            </div>
                            <div class="input-group input-group-sm mb-2">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">鄰</span>
                                </div>
                                <input type="text" class="form-control aboriginal-upload-field" target-key="neighborhood">
                            </div>
                            <div class="input-group input-group-sm mb-2">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">部落人口數</span>
                                </div>
                                <input type="text" class="form-control aboriginal-upload-field" target-key="population">
                            </div>
                            <div class="input-group input-group-sm mb-2">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">原民人口數</span>
                                </div>
                                <input type="text" class="form-control aboriginal-upload-field" target-key="population_aboriginal">
                            </div>
                            <div class="input-group input-group-sm mb-2">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">主要從事產業</span>
                                </div>
                                <input type="text" class="form-control aboriginal-upload-field" target-key="main_production_industry">
                            </div>
                            <div class="input-group input-group-sm mb-2">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">社團或協會組織</span>
                                </div>
                                <input type="text" class="form-control aboriginal-upload-field" target-key="associations_organized">
                            </div>
                            <button type="button" class="btn btn-success btn-sm" id="aboriginal-upload-data-send">提交</button>`,
                            "原住民部落調查數據新增上傳",
                            function(){
                                $("#aboriginal-upload-data-send").click(function(){
                                    var formData = {}
                                    $(".aboriginal-upload-field").each(function(){
                                        formData[$(this).attr("target-key")] = $(this).val()
                                    })
                                    var insertStatus = ajax_call_post(
                                        publicPath + "/napi/obs/hillslopecommunity/abnormal/insert",
                                        formData
                                    )
                                    if (insertStatus) {
                                        if (insertStatus.status === "OK") {
                                            toast_open("原住民資料上傳成功")
                                        }
                                    }
                                })
                            }
                        )
                    })
                }
            )
		}, 1000);
    })
    let result = [thisLayer, geoJson]
    return result
}

function layer_ntc_industry_region(){
    let geoJson = raw_data["工業區範圍"]
    if (!geoJson) {
        geoJson = ajax_call("geojson/hillslope/ntc_industry_region.geojson")
    }
    let thisLayer = L.geoJSON(geoJson, {
        style: function(feature){
            return { color: 'white', weight: 2, opacity: 1, fillOpacity: 0.7, fillColor: 'purple' }
        },
        onEachFeature: function (feature, layer) {
            layer.bindPopup('<div id="other_div" class="w-200">讀取中...</div>');
        }
    }).on('click', function(e){
		let thisFeature = e.layer.feature.properties
		setTimeout(function(){
			$('#other_div').html(`
                <h6>名稱：${thisFeature["名稱"]}</h6>
                <h6>類別：${thisFeature["類別"]}</h6>
                <h6>管理單位：${thisFeature["管理單"]}</h6>`
			)
		}, 1000);
    })
    let result = [thisLayer, geoJson]
    return result
}

function layer_ntc_attraction(){
    let geoJson = raw_data["觀光景點"]
    if (!geoJson) {
        geoJson = ajax_call("geojson/hillslope/ntc_attraction.geojson")
    }
    let thisLayer = L.geoJSON(geoJson, {
		pointToLayer: function(feature, latlng) {
            let iconUrl = "marker_icon/attractions.png"
			return L.canvasMarker(latlng, {
				radius: 15,
				img: {
					url: iconUrl,
					size: [32, 32],
					offset: { x: 0, y: 0 },
				}
			}).bindPopup('<div id="other_div" class="w-200">讀取中...</div>');
		}
    }).on('click', function(e){
		let thisFeature = Object.values(e.layer._eventParents)[0].feature.properties
		setTimeout(function(){
			$('#other_div').html(`
                <h6>名稱：${thisFeature["Name"]}</h6>
                <h6>行政區：${thisFeature["Town"]}</h6>
                <h6>地址：${thisFeature["Add"]}</h6>
                <h6>聯絡電話：${thisFeature["Tel"]}</h6>
                <h6>開放時間：${thisFeature["Opentime"]}</h6>`
			)
		}, 1000);
    })
    let result = [thisLayer, geoJson]
    return result
}

function layer_ntc_forest_road(){
    let geoJson = raw_data["林道"]
    if (!geoJson) {
        geoJson = ajax_call("geojson/hillslope/ntc_forest_road.json")
    }
    let thisLayer = L.geoJSON(geoJson, {
		pointToLayer: function(feature, latlng) {
            let iconUrl = "marker_icon/forest_road.png"
			return L.canvasMarker(latlng, {
				radius: 15,
				img: {
					url: iconUrl,
					size: [32, 32],
					offset: { x: 0, y: 0 },
				}
			}).bindPopup('<div id="other_div" class="w-250">讀取中...</div>');
		}
    }).on('click', function(e){
		let thisFeature = e.layer.feature.properties
		setTimeout(function(){
			$('#other_div').html(`
                <h6>林區：${thisFeature["林區"]}</h6>
                <h6>林道名稱：${thisFeature["林道名稱"]}</h6>
                <h6>出入口名稱：${thisFeature["名稱"]}</h6>
                <h6>類型：${thisFeature["類型"]}</h6>
                <h6>林道規格：${thisFeature["林道規格"]}</h6>
                <h6>林道種類：${thisFeature["林道種類"]}</h6>
                <h6>林道途經聚落：${thisFeature["林道途經聚落"]}</h6>
                <h6>事業區林班：${thisFeature["事業區林班"]}</h6>
                <h6>總長度：${thisFeature["總長度"]}公里</h6>`
			)
		}, 1000);
    })
    let result = [thisLayer, geoJson]
    return result
}

function layer_ntc_hiking_road(){
    let geoJson = raw_data["步道"]
    if (!geoJson) {
        geoJson = ajax_call("geojson/hillslope/hiking_road.geojson")
    }
    let thisLayer = L.geoJSON(geoJson, {
		pointToLayer: function(feature, latlng) {
            let iconUrl = "marker_icon/forest_road.png"
			return L.canvasMarker(latlng, {
				radius: 15,
				img: {
					url: iconUrl,
					size: [32, 32],
					offset: { x: 0, y: 0 },
				}
			}).bindPopup('<div id="other_div" class="w-200">讀取中...</div>');
		},
    }).on('click', function(e){
		let thisFeature = e.layer.feature.properties
		setTimeout(function(){
			$('#other_div').html(`
                <h6>名稱：${thisFeature["name"]}</h6>
                <h6>管理單位：${thisFeature["admin"]}</h6>`
			)
		}, 1000);
    })
    let result = [thisLayer, geoJson]
    return result
}

function layer_ncree_earthquake_damege(){
    const typeMapping = { main: "主要", secondary: "次要" }
    let geoJson = ajax_call("geojson/earthquake/road_damege.geojson")
    let networkRoad = L.tileLayer.wms(publicPath + '/cloud/geoserver/edp3/wms?',{
        layers: 'edp3:ncree_road_network',
        transparent: true,
        format: 'image/png',
        maxZoom: 22,
        pane: "high-zindex-wms-layer"
    })
    let damegeRoad = L.geoJSON(geoJson, {
        style: function(feature){
            return { color: 'red', weight: 5, opacity: 1 }
        },
        onEachFeature: function (feature, layer) {
            layer.bindPopup('<div id="other_div" class="w-200">讀取中...</div>');
        },
        pane: "high-zindex-wms-layer"
    }).on('click', function(e){
		let thisFeature = e.layer.feature.properties
		setTimeout(function(){
			$('#other_div').html(`
                <h6>道路：${thisFeature["buff_name"]}</h6>
                <h6>類型：${typeMapping[thisFeature["class_2"]]}</h6>
                <h6>行政區：${thisFeature["Fullname"]}</h6>
                <h6>長度：${thisFeature["Length"]}m</h6>
                <h6>寬度：${thisFeature["Width"]}m</h6>`
			)
		}, 1000);
    })
    let thisLayer = L.layerGroup([networkRoad, damegeRoad])
    return thisLayer
}

// 人工邊坡示警
function layer_artificial_side_slope_risk(){
    const features = raw_data["人工邊坡示警"] || ajax_call(`${publicPath}/napi/agriculture/artificial_side_slope_risk`).data.features;

    console.log("人工邊坡示警資料：", features);
    // // 因為缺少 schema 且 API 返回的 features 總是沒資料，這裡嘗試測試資料
    // const _mock_testing = false
    // if (_mock_testing || !features || features.length === 0) {
    //     console.warn("人工邊坡示警: API 返回空資料，使用測試假資料");
            
    //     // 測試用假資料
    //     const mockFeatures = [
    //         {
    //             type: "Feature",
    //             geometry: {
    //                 type: "Polygon",
    //                 coordinates: [[
    //                     [121.4, 25.0],
    //                     [121.41, 25.0],
    //                     [121.41, 25.01],
    //                     [121.4, 25.01],
    //                     [121.4, 25.0]
    //                 ]]
    //             },
    //             properties: {
    //                 stn_name: "測試站點A",
    //                 level: 3,
    //                 RISK_LEV: "高危險",
    //                 obs_time: "2026-01-12T14:30:00"
    //             }
    //         },
    //         {
    //             type: "Feature",
    //             geometry: {
    //                 type: "Polygon",
    //                 coordinates: [[
    //                     [121.42, 25.02],
    //                     [121.43, 25.02],
    //                     [121.43, 25.03],
    //                     [121.42, 25.03],
    //                     [121.42, 25.02]
    //                 ]]
    //             },
    //             properties: {
    //                 stn_name: "測試站點B",
    //                 level: 2,
    //                 RISK_LEV: "中危險",
    //                 obs_time: "2026-01-12T14:30:00"
    //             }
    //         },
    //         {
    //             type: "Feature",
    //             geometry: {
    //                 type: "Polygon",
    //                 coordinates: [[
    //                     [121.44, 25.04],
    //                     [121.45, 25.04],
    //                     [121.45, 25.05],
    //                     [121.44, 25.05],
    //                     [121.44, 25.04]
    //                 ]]
    //             },
    //             properties: {
    //                 stn_name: "測試站點C",
    //                 level: 1,
    //                 RISK_LEV: "低危險",
    //                 obs_time: "2026-01-12T14:30:00"
    //             }
    //         }
    //     ];
        
    //     features = mockFeatures;
    // }

    let thisLayer = L.geoJSON(features, {
		style: function(feature, latlng) {
			switch (feature.properties.level) {
                case 1:
                    return { color: 'green', weight: 2, opacity: 1, fillOpacity: 0.5, fillColor: 'green' }
                case 2:
                    return { color: 'yellow', weight: 2, opacity: 1, fillOpacity: 0.5, fillColor: 'yellow' }
                case 3:
                    return { color: 'red', weight: 2, opacity: 1, fillOpacity: 0.5, fillColor: 'red' }
                default:
                    return { color: 'gray', weight: 2, opacity: 1, fillOpacity: 0.5, fillColor: 'gray' }
            }
		},
        onEachFeature: function (feature, layer) {
            layer.bindPopup('<div id="other_div" class="w-250">讀取中...</div>');
        }
    }).on('click', function(e){
		let thisFeature = e.layer.feature.properties
		setTimeout(function(){
			$('#other_div').html(`
                <h6>名稱：${thisFeature["stn_name"]}</h6>
                <h6>危險等級：${thisFeature["RISK_LEV"]}</h6>
                <h6>觀測時間：${thisFeature["obs_time"].replace("T", " ")}</h6>`
			)
		}, 1000);
    })
    let result = [thisLayer, features]
    return result
}